import i18n from "../i18n";

export const mongoliaDestinationReasons = [
  {
    title: "Gallop through the vast fields of Mongolia",
    description: (
      <>
        “One of the <span className="tw-text-primary-5">best trips</span> &
        horse riding experience in my life”
      </>
    ),
    thumbnailSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    reviewer: {
      name: "Alex",
      profilePictureSrc:
        "https://d1puf2nnbcyl9q.cloudfront.net/6fb7b0d436666805bcb8ba02bcd62d19-m",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 14%, rgba(0, 0, 0, 0) 28.5%, rgba(0, 0, 0, 0) 67%, rgba(0, 0, 0, 0.4) 77.26%)",
  },
  {
    title: "Soak in the authentic nomadic yurt experience",
    description: (
      <>
        “I really enjoyed the{" "}
        <span className="tw-text-primary-4">people and culture</span> on this
        one-of-a-kind trip!”
      </>
    ),
    thumbnailSrc: "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_yurt_pic.png",
    reviewer: {
      name: "Alicia",
      profilePictureSrc:
        "https://d1puf2nnbcyl9q.cloudfront.net/34d112c61000cb4a073f21e19fe48810-m",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.5) 21.05%, rgba(0, 0, 0, 0) 29.88%, rgba(0, 0, 0, 0) 68.91%, rgba(0, 0, 0, 0.5) 81.27%)",
  },
  {
    title: "Run across the world renown Gobi Desert",
    description: (
      <>
        “I had an amazing time{" "}
        <span className="tw-text-primary-4">riding camels</span>
        and climbing the sane dunes to{" "}
        <span className="tw-text-primary-4">
          watch the sun set in the Gobi desert
        </span>
        "
      </>
    ),
    thumbnailSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_desert_pic.png",
    reviewer: {
      name: "Jason Hee",
      profilePictureSrc:
        "https://d1puf2nnbcyl9q.cloudfront.net/6122fc593b17cf38585ce5f7c9840a24-s",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.29) 15.56%, rgba(0, 0, 0, 0) 23.15%, rgba(0, 0, 0, 0) 69.8%, rgba(0, 0, 0, 0.58) 74.58%)",
  },
  {
    title: "Immerse in the rich culture of Mongolia",
    description: (
      <>
        "I can't believe I tried{" "}
        <span className="tw-text-primary-4">horse & camel milk</span>. This trip
        was such an eye-opening experience. .”
      </>
    ),
    thumbnailSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_eagle_pic.png",
    reviewer: {
      name: "Tan",
      profilePictureSrc:
        "https://d1puf2nnbcyl9q.cloudfront.net/1117d10d45e1e185871d5f51c42903c7-m",
    },
    gradient:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.312) 18.89%, rgba(0, 0, 0, 0) 33.94%, rgba(0, 0, 0, 0) 53.36%, rgba(0, 0, 0, 0.468) 75.46%)",
  },
];

export const japowDestinationReasons = [
  {
    title: "Powder-packed mountain playgrounds",
    thumbnailSrc:
      "https://www.go-nagano.net/hubfs/Imported_Blog_Media/20427_ext_01_en_0_L.jpg",
  },
  {
    title: "Soak & relax in charming onsen towns",
    thumbnailSrc:
      "https://www.mountainwatch.com/wp-content/uploads/2018/04/smaller-Nozawa2016_outdoor_onsen_Radich-4016-1024x643.jpg",
  },
  {
    title: "Slice through hidden tree runs",
    thumbnailSrc:
      "https://cdn.skimag.com/wp-content/uploads/2021/07/CLS6205-web.jpg?width=730",
  },
  {
    title: "Devour ramen like you just skied Mt. Fuji",
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1003260image_2025-05-28_16-31-15.png",
  },
];

export const japowWhyUsReasons = [
  {
    title: "A hosted experience, discover new lines",
    description: (
      <>
        We sniff out <span className="tw-text-primary-main">fresh lines</span>{" "}
        and know where the good stuff hides. Tag along—we'll share our{" "}
        <span className="tw-text-primary-main">favourite trails</span>.
      </>
    ),
    thumbnailSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    videoSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/187368720250528-161924.mp4",
  },
  {
    title: "Action-packed, perfectly planned",
    description: (
      <>
        <span className="tw-text-primary-main">Private transfers</span> that
        will whisk you away to{" "}
        <span className="tw-text-primary-main">fresh resorts</span> and epic
        adventures every single day!
      </>
    ),
    thumbnailSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    videoSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/snow_banner_secure_vid_2.mov",
  },
  {
    title: "Push boundaries, ride with your level",
    description: (
      <>
        Master your{" "}
        <span className="tw-text-primary-main">
          first turns or chase fresh pow
        </span>{" "}
        with people who match your pace and stoke.
      </>
    ),
    thumbnailSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    videoSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/snow_banner_professional_vid.mov",
  },
  {
    title: "Beyond the snow, stoke is better shared",
    description: (
      <>
        Carve, crash, send, and celebrate — ride with a crew that pushes you to{" "}
        <span className="tw-text-primary-main">new heights and new highs!</span>
      </>
    ),
    thumbnailSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/mongolia_horse_pic.png",
    videoSrc:
      "https://d1puf2nnbcyl9q.cloudfront.net/snow_banner_community_vid.mov",
  },
];

export const japowReviews = [
  {
    title: '"Visiting multiple ski resorts"',
    description: (
      <>
        “The combination of multiple ski resorts gave us a truly immersive japow
        experience"
      </>
    ),
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/717358image_2025-05-28_19-57-32.png",
    reviewer: {
      name: "Azreena",
      profilePictureSrc:
        "https://d1puf2nnbcyl9q.cloudfront.net/dfe71355629c283955562229e4eee433-s",
    },
  },
  {
    title: '"The people I met on the trip"',
    description: <>"Great company and loads of fun! major W"</>,
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1261057IMG_6462.jpg",
    reviewer: {
      name: "Kelly",
      profilePictureSrc:
        "https://d1puf2nnbcyl9q.cloudfront.net/7684f4a6151b6dea8107c670fe897572-s",
    },
  },
  {
    title: '"Riding with my level"',
    description: (
      <>
        "I loved that there were people of different levels to snowboard with
        and learn from!"
      </>
    ),
    thumbnailSrc:
      "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1082723IMG_6463.jpg",
    reviewer: {
      name: "Amrbose",
      profilePictureSrc:
        "https://d1puf2nnbcyl9q.cloudfront.net/0d07f741f72e5d78fe4c96c102634751-s",
    },
  },
  {
    title: '"Night skiing hits different"',
    description: (
      <>"Nice slopes I especially liked the night skiing at Goryu!"</>
    ),
    thumbnailSrc:
      "https://image.kkday.com/v2/image/get/w_960%2Cc_fit%2Cq_55%2Ct_webp/s1.kkday.com/product_156189/20231124095758_aTWrC/jpg",
    reviewer: {
      name: "Evan",
      profilePictureSrc:
        "https://d1puf2nnbcyl9q.cloudfront.net/b0e261119c7466b1714bceb7ae6d8fca-s",
    },
  },
];
const createFaqs = (faqKeys) =>
  faqKeys.map((key) => ({
    key,
    get question() {
      return i18n.t(`landing.faqs.questions.${key}.question`);
    },
    get answer() {
      if (key === "travel_insurance") {
        return (
          <>
            <p>
              <p className="tw-font-bold tw-mb-2">
                {i18n.t(`landing.faqs.questions.${key}.answer_title1`)}
              </p>
              <p>{i18n.t(`landing.faqs.questions.${key}.answer_detail1`)}</p>
            </p>{" "}
            <p>
              <p className="tw-font-bold tw-mb-2 tw-mt-2">
                {i18n.t(`landing.faqs.questions.${key}.answer_title2`)}
              </p>
              <p>{i18n.t(`landing.faqs.questions.${key}.answer_detail2`)}</p>
            </p>
          </>
        );
      }

      return (
        <p>
          <p className="tw-font-bold tw-mb-2">
            {i18n.t(`landing.faqs.questions.${key}.answer_title`)}
          </p>
          <p>{i18n.t(`landing.faqs.questions.${key}.answer_detail`)}</p>
        </p>
      );
    },
  }));

const japowFaqKeys = [
  "what_included_snow",
  "lessons_taught_by",
  "equipment_rental",
  "what_to_bring",
  "book_flights",
  "cancellation",
  "travel_insurance",
];

export const japowFaqs = createFaqs(japowFaqKeys);
